_ = require('lodash')

GroupDataService = ($filter) ->
  getPolicyData: ->
    policyDatas = [
      {type:'1' , image: 'publicPolicy', name: $filter('translate')('_GROUP.PUBLIC_GROUP') , description: $filter('translate')('_GROUP.PUBLIC_GROUP_DES')}
      {type:'0' , image: 'privatePolicy', name: $filter('translate')('_GROUP.PRIVATE_GROUP') , description: $filter('translate')('_GROUP.PRIVATE_GROUP_DES')}
    ]
  getPermissionData: ->
    permissionData = [
      {
        name: $filter('translate')('_GROUP_MEMBERS.ADMIN')
        value: 'admin'
      }
      {
        name: $filter('translate')('_GROUP_MEMBERS.MEMBER')
        value: 'member'
      }
      {
        name: $filter('translate')('_GROUP_MEMBERS.DELETE_MEMBER')
        value: 'delete'
      }
    ]


GroupDataService.$inject = [
  '$filter'
]

module.exports = GroupDataService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/group-data-service.coffee